<template>
    <div ref="parentContainer" class="parent">
      <div class="div1" style="transform: translate(15%, 0);">
        <img src="../assets/sensitive-one/logo-sensitive-pro-alivio.png" alt="Imagen de prueba" class="image">
      </div>
      <div class="div2 animated">
        <p>
          <strong>Control de la Hipersensibilidad Dentinaria:</strong><br>
          Control de Factores Predisponentes
        </p>
      </div>
      <div class="div33 animated">
        <img src="../assets/sensitive-one/titulo1.png" alt="Icono HD" class="icono">
      </div>
      <div class="div4 animated">
        <p class="texto1">Remoción de <br> barrillo dentinal</p>
        <p class="texto2">Túbulos abiertos <br> y permeables</p>
      </div>
      <div class="div5 animated">
        <img src="../assets/sensitive-one/flechas.png" alt="Imagen Contenedor 5" class="imagen5">
      </div>
      <div class="div6 animated">
        <img src="../assets/sensitive-one/partefinal.png" alt="Imagen Contenedor 6" class="imagen6">
      </div>
      <div class="div7 animated">
        <p class="texto7">O'Toole S, Bartlett D. The relationship between dentine hypersensitivity, dietary acid intake and erosive tooth wear. J Dent. 2017 Dec;67:84-87. dol:10.1016/J.Jdent.2017.10.002.</p>
      </div>
    </div>
  </template>
  
  <script setup>
  import { onMounted, ref } from 'vue';
  
  const parentContainer = ref(null);
  
  onMounted(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );
  
    if (parentContainer.value) {
      const children = parentContainer.value.children;
      for (const child of children) {
        if (!child.classList.contains("div1")) {
          observer.observe(child);
        }
      }
    }
  });
  </script>
  
  <style scoped>
  .parent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(12, 1fr);
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background-image: url('../assets/sensitive-one/fondo2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  
  .div1 { grid-area: 1 / 1 / 2 / 4; }
  .div2 { grid-area: 2 / 4 / 3 / 10; }
  .div33 { grid-area: 3 / 5 / 7 / 9; }
  .div4 { grid-area: 5 / 9 / 7 / 11; }
  .div5 { grid-area: 7 / 4 / 8 / 10; }
  .div6 { grid-area: 8 / 4 / 11 / 10; }
  .div7 { grid-area: 12 / 3 / 13 / 11; }
  
  .parent > div:not(.div4) {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .div1 .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .div2 p {
    margin: 0;
    padding: 0;
    font-size: 25px;
    font-weight: 300;
    text-align: center;
    line-height: 23px;
    font-family: 'ColgateReady-Regular';
    color: #443698;
  }
  
  .div33 .icono {
    width: 80%;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  .div4 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 10px 0;
    gap: 16px;
    height: 100%;
  }
  .div4 p {
    margin: 0;
    padding-left: 10px;
    border-left: 2px solid #443698;
    font-size: 16px;
    font-family: 'ColgateReady-Regular';
    color: #443698;
    text-align: left;
    line-height: 1.4;
  }
  
  .div5 .imagen5 {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  }
  
  .div6 .imagen6 {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  .div7 p {
    margin: 0;
    font-size: 12px;
    font-family: 'ColgateReady-Italic';
    font-style: italic;
    color: #5D5A59;
    white-space: nowrap;
    text-align: center;
  }
  
  @media (max-width: 400px) {
    .parent {
      display: flex;
      flex-direction: column;
      gap: 5px;
      height: auto;
    }
    .parent > div {
      width: 100%;
      height: auto;
    }
  }
  
  @media (min-width: 401px) {
    .parent {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: repeat(12, 1fr);
    }
  }
  
  .animated {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 2s ease-out, transform 2s ease-out;
  }
  
  .animated.visible {
    opacity: 1;
    transform: translateY(0);
  }
  </style>
  